module.exports = __webpack_public_path__ + "BGL_Dark-1024x991.62fbf4f.png";